import { AxiosResponse } from "axios";
import api from "../Interceptors/Interceptor";
import ApiResponse from "../Models/ApiResponse";

export const SECTION_TYPE = {
    IMAGE: "IMAGE",
    VIDEO: "VIDEO",
    SLIDESHOW: "SLIDESHOW",
    TEXT: "TEXT",
} as const;

export type SectionType = (typeof SECTION_TYPE)[keyof typeof SECTION_TYPE];

export const MOVE_DIRECTION = {
    UP: "UP",
    DOWN: "DOWN",
} as const;

export type MoveDirection = (typeof MOVE_DIRECTION)[keyof typeof MOVE_DIRECTION];

export interface IKnowledgeArticleSectionModel {
    uuid: string;
    knowledgeArticleUuid: string;
    title: string;
    sectionType: SectionType;
    /** Only meaningful for a TEXT section. */
    content?: string;
    /** Whether `title` renders on the article page. Undefined is treated as shown (matches the backend's
     *  own null-defaults-to-true rule on create). */
    showTitle?: boolean;
    displayOrder: number;
}

export interface IKnowledgeArticleSectionCrudModel {
    knowledgeArticleUuid: string;
    title: string;
    sectionType: SectionType;
    content?: string;
    showTitle?: boolean;
}

/** The section endpoints are not a CrudController (no list/select-item), hence no BaseService. An article's
 *  sections normally arrive with the article itself (GET knowledge-article/{uuid}). */
export class KnowledgeArticleSectionService {
    public async fetchByArticle(knowledgeArticleUuid: string): Promise<AxiosResponse<ApiResponse<IKnowledgeArticleSectionModel[]>>> {
        return api.get(`v1/knowledge-article-section/by-article/${knowledgeArticleUuid}`);
    }

    /** Responds with the new section's uuid. */
    public async postItem(section: IKnowledgeArticleSectionCrudModel): Promise<AxiosResponse<ApiResponse<string>>> {
        return api.post("v1/knowledge-article-section", section);
    }

    public async putItem(uuid: string, section: IKnowledgeArticleSectionCrudModel): Promise<AxiosResponse<ApiResponse<void>>> {
        return api.put(`v1/knowledge-article-section/${uuid}`, section);
    }

    public async deleteItem(uuid: string): Promise<AxiosResponse<ApiResponse<void>>> {
        return api.delete(`v1/knowledge-article-section/${uuid}`);
    }

    public async moveSection(uuid: string, direction: MoveDirection): Promise<AxiosResponse<ApiResponse<void>>> {
        return api.put(`v1/knowledge-article-section/${uuid}/move`, null, { params: { direction } });
    }
}
